import './App.css'
import React, { Component } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  browserHistory,
} from 'react-router-dom'
import Menu from './Menu'
import NoMatch from './NoMatch'
import { routes } from './config'

const App = () => {
  return (
    <Router history={browserHistory}>
      <div className="App">
        <div className="App_menu">
          <Route component={Menu} />
        </div>
        <div className="App_content">
          <div className="App_links">
            <a href="https://my.small.chat/">Login</a>
          </div>
          <Switch>
            {routes}
            <Route
              path="/"
              exact
              render={() => <Redirect to="/installation" />}
            />
            <Route component={NoMatch} />
          </Switch>
        </div>
      </div>
    </Router>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/App.js